// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"cdcc0fa6","408":"ae92f288"}[chunkId] + ".chunk.css";
};